define('SageDotCom/Components/ProductCardAlignment',[
    "jquery",
    "eventManager",
    "slick",
    "SageDotCom/Utility/sageMatchHeight"
], function ($, eventManager, slick, SageMatchHeight) {
    function ProductCardAlignment() { }

    ProductCardAlignment.prototype.init = function init() {
        var that = this;

        this.productCardLogic();

        eventManager.subscribe("product card refresh heights", function ($el) {
            setTimeout(function () {
                if (that.shouldProductCardsResize($el)) {
                    that.refreshProductCardHeights();
                }
            }, 50);
        });

        var timeoutSS;
        var saveWidthSS = $(window).width();
        $(window).resize(function () {
            if (saveWidthSS !== $(window).width()) {
                saveWidthSS = $(window).width();
                clearTimeout(timeoutSS);
                timeoutSS = setTimeout(function () {
                    that.refreshProductCardHeights();
                }, 1000);
            }
        });
    }

    ProductCardAlignment.prototype.productCardLogic = function () {
        //product card
        $(".sage-product-card:not(.experience-editor)").each(function () {
            $(this).children(":not(.sage-product-card-promo-header)").wrapAll("<div class='sage-product-card-wrapper'></div>");
            $(this).find(".sage-product-card-content").wrapAll("<div class='sage-product-card-body'></div>");
        });
        ////product card alt
        $(".sage-product-card-alt:not(.experience-editor)").each(function () {
            $(this).children(":not(.sage-product-card-promo-header-alt)").wrapAll("<div class='sage-product-card-wrapper-alt'></div>");
        });

        //for 3 to 1 aspect ratio, wrap all but first card into a single div
        $(".score-flex-box.aspect-ratio-one-three").each(function () {
            $(this).children(".flex-item:not(:first)").wrapAll("<div class='sage-product-card-ratio-container'><div class='sage-product-card-scroller'></div></div>");
        });
        

        this.adjustProductCardHeight();
    };

    ProductCardAlignment.prototype.adjustProductCardHeight = function () {
        //remove the inner body elements
        $(".sage-product-card-body").find(".sage-product-card-content").children().unwrap();
        $(".sage-product-card-body").addClass("sage-product-card-content");


        //match height on the containers //twice(!!!required) as the logic in between reposition the elements
        this.sageProductCardMatchHeight();

        this.matchFeatures();
    };

    var getResizeScopesForResolution = function () {
        var windowWidth = $(window).width();

        var isSlick = $(".slick-cards") !== null && $(".slick-cards").length > 0;
        isSlick = isSlick || ($(".slicked-table") !== null && $(".slicked-table").length > 0);
        
        var baseSelector = "";
        if (windowWidth < 768) {
            if (!isSlick) {
                return [];
            }
        }
        else if (windowWidth < 1080) {
            //Tablet - only match the first two that match
            //One three - the three are in a carousel together
            //One two - not even css, probably redundant now
            //Therefore - first two product cards, unless is the 1-3 aspect ratio, in which case it's all of them except the first
            baseSelector = ".aspect-ratio-one-three .flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-three .flex-item:has(.#CARDTYPE#):first):nth-child(-n+4), .aspect-ratio-one-two .flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-two .flex-item:has(.#CARDTYPE#):first):nth-child(-n+4), .flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-three .flex-item:has(.#CARDTYPE#), .aspect-ratio-one-two .flex-item:has(.#CARDTYPE#)):nth-child(-n+4)";
        }
        else {
            baseSelector = ".flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-three .flex-item:has(.#CARDTYPE#):first, .aspect-ratio-one-two .flex-item:has(.#CARDTYPE#):first)";
        }

        if (isSlick) {
            baseSelector = ".flex-item:has(.#CARDTYPE#):not(.aspect-ratio-one-three .flex-item:has(.#CARDTYPE#):first, .aspect-ratio-one-two .flex-item:has(.#CARDTYPE#):first)";
        }

        var productCardScope = baseSelector.replace(/#CARDTYPE#/g, "sage-product-card");
        var productCardAltScope = baseSelector.replace(/#CARDTYPE#/g, "sage-product-card-alt");

        return [productCardScope, productCardAltScope];
    }

    ProductCardAlignment.prototype.shouldProductCardsResize = function ($el) {
        //$el is the element that was interacted with
        var scopes = getResizeScopesForResolution();
        if (scopes.length === 0) {
            return false;
        }
        else {
            return $el.parents(scopes[0]).length > 0 || $el.parents(scopes[1]).length > 0;
        }
    }

    ProductCardAlignment.prototype.sageProductCardMatchHeight = function () {
        var scopes = getResizeScopesForResolution();
        if (scopes.length === 0) {
            //mobile
            $(".sage-product-card .sage-product-card-header, " +
                ".sage-product-card .sage-product-card-body, " +
                ".sage-product-card-content-alt, " +
                ".sage-product-card-alt .sage-product-card-titles-container, " +
                ".sage-product-card-alt .sage-product-card-section-title-alt, " +
                ".sage-product-card-alt .sage-product-card-section-title-alt .sage-product-card-subtitle, " +
                ".sage-product-card-price-selection, " +
                ".sage-product-card-alt .sage-product-card-price-options-area, " +
                ".sage-product-card-alt .sage-product-card-actions-area, " +
                ".sage-product-card-addon-alt, " +
                ".sage-product-card-alt .body .sage-product-card-features-alt, " +
                ".sage-product-card-alt .header, " +
                ".sage-product-card-alt .body, " +
                ".sage-product-card-alt .footer").matchHeight("remove");
        }
        else {
            var productCardScope = $(scopes[0]);
            var productCardAltScope = $(scopes[1]);

            if (productCardScope && productCardScope.length > 0) {
                SageMatchHeight.prototype.applyBinding(productCardScope.find(".sage-product-card-header"), true, { byRow: true });
                SageMatchHeight.prototype.applyBinding(productCardScope.find(".sage-product-card-body"), true, { byRow: true });
            }

            if (productCardAltScope && productCardAltScope.length > 0) {
                SageMatchHeight.prototype.productCardBindings(productCardAltScope, true, { byRow: true });
            }
        }
    }

   

    ProductCardAlignment.prototype.refreshProductCardHeights = function() {
        //unset
        $(".product-card-inner-height-auto-set").css("height", "");
        $(".product-card-inner-height-auto-set-buttons").css("height", "");
        
        
        //match height on the containers
        this.sageProductCardMatchHeight();
        
        $("table:not(.clone)").find(".sage-product-card-body").each(function (i, item) {
            if ($("table.clone").find(".sage-product-card-body")[i]) {
                $($("table.clone").find(".sage-product-card-body")[i]).height($(item).height());
            }
        });
    };

    ProductCardAlignment.prototype.matchFeatures = function() {
        $('.sage-product-card-features-alt').each(function() {
            var $container = $(this);

            var $featuresSpot = $container.find('.score-content-spot.features');

            // Get only the elements that come before the features content spot and wrap them
            $($featuresSpot.prevAll().get().reverse()).wrapAll('<div class="pre-features-content"></div>');
        });

        SageMatchHeight.prototype.applyBinding($('.pre-features-content'), true);

    };

    return new ProductCardAlignment();
});
